export default __webpack_public_path__ + "static/media/GenWanMinTW-SB-01.9c6ecc60.woff";